import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IPartyContactFields {
		id?: any;
		partyId?: any;
		typeId?: any;
		value?: any;
		isDefault?: any;
		changedBy?: any;
		datestamp?: any;
		status?: any;
}

export class PartyContactFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public partyId: IEntityModelField = { name: "partyId", displayName: "Party Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public typeId: IEntityModelField = { name: "typeId", displayName: "Type Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public value: IEntityModelField = { name: "value", displayName: "Value", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public isDefault: IEntityModelField = { name: "isDefault", displayName: "Is Default", fieldType: FieldType.Byte, pattern: "NameGeneric", required: true };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric" };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.partyId);
		this.push(this.typeId);
		this.push(this.value);
		this.push(this.isDefault);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class PartyContactDTO implements IEntityModel {
	protected partyContactName: string = "PartyContactModel";
	protected partyContactKeyField: string = "id";
	protected partyContactDisplayName: string = "Party Contact|Party Contacts";
	protected partyContactFields = new PartyContactFields();
	public get name(): string { return this.partyContactName };
	public get keyField(): string { return this.partyContactKeyField };
	public get displayName(): string { return this.partyContactDisplayName };
	public get fields(): PartyContactFields { return this.partyContactFields };

	constructor() {};
}
